class CookieFunctions {
    // Set a cookie with the given name, value, and expiration time in milliseconds
    setCookie(name, value, millis) {
        try {
            if (!name || !value || !millis) {
                throw new Error("Invalid input parameters");
            }

            const expiryDate = new Date(Date.now() + millis).toUTCString();

            document.cookie = `${name}=${value}; expires=${expiryDate}; path=/`;

            const message = this.getCookie(name)
                ? `Cookie ${name} got updated to ${value}`
                : `Successfully created ${name} with ${value}`;

            return JSON.stringify({ message });
        } catch (error) {
            return JSON.stringify({ error: error.message });
        }
    }

    // Retrieve the value of a cookie by name
    getCookie(name) {
        try {
            if (!name) {
                throw new Error("Cookie name is required");
            }

            const cookies = document.cookie.split('; ').reduce((acc, cookie) => {
                const [key, val] = cookie.split('=');
                acc[key] = val;
                return acc;
            }, {});

            if (!(name in cookies)) {
                throw new Error(`Cookie with name ${name} does not exist`);
            }

            return cookies[name];
        } catch (error) {
            return JSON.stringify({ error: error.message });
        }
    }

    // Delete a cookie by name
    deleteCookie(name) {
        try {
            if (!name) {
                throw new Error("Cookie name is required");
            }

            const existingValue = this.getCookie(name);

            if (!existingValue) {
                throw new Error(`Cookie with name ${name} does not exist`);
            }

            // Set the cookie's expiry date to the past to delete it
            document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/`;

            return JSON.stringify({ message: "Delete successful" });
        } catch (error) {
            return JSON.stringify({ error: error.message });
        }
    }
}

export default CookieFunctions;